import React from "react";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import { Header2 } from "../components/elements/Header";
import { Avatar, ImagePlacer, Initials } from "../components/elements/Avatar";
import ProfileHeader from "../components/ProfileHeader";
import bodytrait from "../assets/svg/bodytrait.svg";
import setting from "../assets/svg/setting.svg";
import chat from "../assets/svg/chat.svg";
import { DropDownList, ListItem } from "../components/elements/List";
import Buttons from "../components/elements/Button";
import { navigate } from "@reach/router";

const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const Name = styled.h1`
  font-family: Playfair Display;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #fffcf2;
`;

const LabelSvg = styled.img`
  display: block;
  top: 0;
  left: 0;
  overflow: visible;
  width: 39px;
  height: 18px;
`;
const Edit = styled.p`
  font-family: Poppins;
  color: #fdfffc;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  cursor: pointer;
  &:hover {
    color: #fd9e46;
    cursor: pointer;
  }
`;
export default function Profile(props) {
  const { user, Logout } = useAuth();

  const getInitials = () => {
    const initials = user.data
      ? user.data.fullName.trim().split(" ")
      : user.fullName.trim().split(" ");
    if (initials.length === 1) return `${initials[0].charAt(0)}`;
    else
      return `${initials[0].charAt(0)}${initials[initials.length - 1].charAt(
        0
      )}`;
  };

  const short = getInitials();

  return (
    <>
      <BackBtn>
        <ProfileHeader />
      </BackBtn>
      <Header2 style={{ marginTop: "15px" }}>My profile</Header2>
      <div
        style={{ marginTop: "20px" }}
        className="d-flex justify-content-center"
      >
        {user && user.avatar ? (
          <>
            <ImagePlacer className="d-flex justify-content-center">
              {user && user.avatar ? (
                <Avatar src={user.avatar} />
              ) : (
                <Initials className="align-self-center">{short}</Initials>
              )}
            </ImagePlacer>
          </>
        ) : (
          <>
            <ImagePlacer className="d-flex justify-content-center">
              {user.data && user.data.avatar ? (
                <Avatar src={user.data.avatar} />
              ) : (
                <Initials className="align-self-center">{short}</Initials>
              )}
            </ImagePlacer>
          </>
        )}
      </div>
      <div
        style={{ marginTop: "16px" }}
        className="d-flex justify-content-center"
      >
        {user.data && user.data.fullName ? (
          <Name>{user.data.displayName}</Name>
        ) : (
          <Name>{user.fullName}</Name>
        )}
      </div>
      <div
        style={{ marginTop: "16px" }}
        className="d-flex justify-content-center"
      >
        <Edit onClick={() => navigate("/edit-profile")}>Edit Profile</Edit>
      </div>
      <div style={{ marginTop: "13px" }} className="px-5">
        <DropDownList>
          <ListItem>
            <div onClick={() => navigate("/body-trait")} className="d-flex row">
              <LabelSvg src={bodytrait} />
              Body Traits
            </div>
          </ListItem>
          <ListItem>
            <div onClick={() => navigate("/settings")} className="d-flex row">
              <LabelSvg src={setting} />
              Settings
            </div>
          </ListItem>
          <ListItem>
            <div className="d-flex row">
              <LabelSvg src={chat} />
              Chat with us!
            </div>
          </ListItem>
        </DropDownList>
      </div>
      <NextBtn onClick={Logout}>Logout</NextBtn>
    </>
  );
}
